export const POST_MESSAGE_SCRIPT_GET_CONFIGURATION = "script_get_configuration";
export const POST_MESSAGE_EDITOR_GET_AUTH = "editor_get_auth";
export const POST_MESSAGE_WIDGET_INIT = "widget_init";

export const INITIALIZED_WIDGET = "initializedWidget";

export const initWidget = () => {
  const targetWindow = window.top;

  targetWindow.postMessage(
    {
      type: POST_MESSAGE_WIDGET_INIT,
      message: `${INITIALIZED_WIDGET}`,
    },
    "*"
  );
};
